import React, { FC } from 'react'
import { Box, Center, Grid, Stack } from '@lojinha/design-system'
import styled from 'styled-components'
import { NutritionTable } from '../nutrition-table'
import {
  InsideProducts,
  NutritionFact,
} from '../../../modules/page-content/page-content.types'
import { Ingredients } from '../ingredients'
import { AllergensInfo } from '../allerginics-info'
import { Description } from '../description'

const Divisor = styled(Grid)(
  ({ theme }) => `
    background: ${theme.colors.gray200};
    height: 100%;
    width: 1px;

    ${theme.media.above('md')}{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      bottom: 0;
    }

    ${theme.media.below('lg')}{
      height: 1px;
      width: 100%;
      margin-top: ${theme.space.x40};
    }
  `
)

type DetailsProps = {
  id: string
  name: string
  ingredients?: string | null
  allergenics?: string | null
  description?: string | null
  products?: InsideProducts[]
  nutritionFacts?: NutritionFact | null
}

export const Details: FC<DetailsProps> = ({
  id,
  name,
  ingredients,
  products,
  description,
  allergenics,
  nutritionFacts,
}) => {
  const allIngredients =
    products ?? (ingredients ? [{ id, name, ingredients }] : [])

  return (
    <Box
      py="x64"
      borderWidth={0}
      borderColor="gray200"
      borderStyle="solid"
      borderTopWidth={1}
      borderBottomWidth={1}
      htmlAttrs={{ style: { position: 'relative' } }}
    >
      <Center>
        <Grid
          gridTemplateColumns={[
            'repeat(24, 1fr)',
            'repeat(24, 1fr)',
            'repeat(12, 1fr)',
          ]}
        >
          <Grid gridColumn={['2 / 24', '2 / 24', '2 / 6']}>
            <Stack margin="x40">
              {description && <Description description={description} />}
              {allIngredients.length > 0 && (
                <Ingredients allIngredients={allIngredients} />
              )}
              {allergenics && <AllergensInfo allergenics={allergenics} />}
            </Stack>
          </Grid>
          <Divisor gridColumn={['1 / 25', '1 / 25', '7 / 7']} />
          <Grid gridColumn={['1 / 25', '1 / 25', '8 / 12']}>
            {nutritionFacts && (
              <NutritionTable nutritionFacts={nutritionFacts} />
            )}
          </Grid>
        </Grid>
      </Center>
    </Box>
  )
}
